import { ValidationError } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ValidatorError';
import { Validator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
export class TrackEventActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.category) {
            throw new ValidationError('The event track category is required');
        }
        if (!model.action) {
            throw new ValidationError('The event track action is required');
        }
        if (model.value &&
            !model.value.match('^{{.+}}$|^[0-9]+(.[0-9]{1,3})?$')) {
            throw new ValidationError('The value does not match the requirements');
        }
    }
}
